import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
import { activateAbTestByEvent } from '../../scripts/ab/registry';

// AB test ab-quotation-sticky-recap - Recap sticky en haut (étapes + réassurance + promo) sur mobile

export default (): AlpineComponentTryba => ({
    init() {
        window.addEventListener('ab-quotation-sticky-recap', () => {
            activateAbTestByEvent('ab-quotation-sticky-recap');
            this.$store.ab.quotationStickyRecap = true;
        });
    },
});
